export const RED = "#ff9aa2";
export const GREEN = "#e2f0cb";
export const LIGHT_GRAY = "#f0f0f0";
export const DARK_GRAY = "#0f0f0f";
